import React from "react";
import "./style.css";
import video from "../../res/project1.mov";
import Footer from "../footer";

class Project1 extends React.Component {
  componentDidMount() {
    window.scrollTo(0, 0);
  }

  render() {
    const openInNewTab = (url) => {
      const newWindow = window.open(url, "_blank", "noopener,noreferrer");
      if (newWindow) newWindow.opener = null;
    };
    return (
      <>
        <div className="project1">
          <div className="project1-header">
            <div className="project1-heading">Social Media App</div>
          </div>
          <div className="project1-body">
            <div className="project1-body-text">
              This is app enable user to post images with caption by logging in
              from Google Id. Here, user can create, read, update and delete the
              posts and comments to other's post as well. All the images,
              captions and comments will be stored in Firebase.
            </div>
            <div className="project1-video">
              <video
                className="video"
                autoPlay
                playsInline
                muted
                loop={true}
                src={video}
              ></video>
            </div>
            <div className="project1-link">
              <div
                className="project1-link-inner"
                onClick={() =>
                  openInNewTab("https://reactsocialapptutorial.web.app/")
                }
              >
                Visit Website {">"}
              </div>
            </div>
          </div>
        </div>
        <Footer />
      </>
    );
  }
}

export default Project1;
